'use strict';

function isEmail(email) { //eslint-disable-line
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; //eslint-disable-line
    if (!regex.test(email)) {
        return false;
    }
}

module.exports = function () {
    // Hypothesis Email Sign-Up
    var successFormText;
    var emailField = $('#email-SignUp-Footer');
    var emailPlaceholderText = $('.footer-signup #email-SignUp-Footer').attr('placeholder');
    var subscribeSMSFormWrapper = $('.footer-signup');

    function resetSubscribeForm() { //eslint-disable-line
        subscribeSMSFormWrapper.removeClass('subscribeSignupSuccess subscribeSignupError');
        emailField.attr('placeholder', emailPlaceholderText);
        $('#errorMsg').removeClass('block');
        emailField.val();
    }

    $('.footer-email-hyp #email-SignUp-Footer').on('focus', function () {
        resetSubscribeForm();
    });

    $('.footer-email-hyp').submit(function (e) {
        e.preventDefault();

        var $form = $(this);
        var url = $form.attr('action');
        var emailValue = emailField.val();
        var formData = $form.serialize();

        successFormText = 'You\'re signed up.';

        if (!subscribeSMSFormWrapper.hasClass('subscribeSignupSuccess')) {
            if (isEmail(emailValue) === false || emailValue === '' || emailValue === emailPlaceholderText) {
                subscribeSMSFormWrapper.removeClass('subscribeSignupSuccess');
                subscribeSMSFormWrapper.addClass('subscribeSignupError');
                emailField.attr('placeholder', emailPlaceholderText);
                $('#errorMsg').addClass('block');
            } else {
                $.ajax({
                    url: url,
                    type: 'POST',
                    crossDomain: true,
                    data: formData,
                    dataType: 'jsonp'
                }).always(function () {
                    emailField.val('');
                    emailField.attr('placeholder', successFormText);
                    subscribeSMSFormWrapper.removeClass('subscribeSignupError');
                    subscribeSMSFormWrapper.addClass('subscribeSignupSuccess');
                });
            }
        } else {
            resetSubscribeForm();
        }
    });
};
